import { Shimmer } from '@wartek-id/shimmer'

import { range } from '@/utils/array'

export const ContentLoader = () => {
  return (
    <div className="flex items-center gap-4">
      <Shimmer width={100} height={10} />
      <Shimmer width={20} height={10} />
      <Shimmer width={200} height={10} />
    </div>
  )
}

export const ContentRowLoader = ({ rows = 5 }) => {
  return (
    <div className="flex flex-col gap-4">
      {range(1, rows).map((item) => (
        <ContentLoader key={item} />
      ))}
    </div>
  )
}
